import get from 'lodash/get';

import {
  SET_TRANSLATION_DATA_FOR_ISO,
  SET_TRANSLATIONS_STATUS_FOR_ISO
} from 'zoomforth_codesbane_editor/action_types.js';

export default (state = {}, action)=> {

  switch (action.type) {

  case SET_TRANSLATION_DATA_FOR_ISO: {
    return {
      ...state,
      [action.iso]: action.data
    };
  }

  case SET_TRANSLATIONS_STATUS_FOR_ISO: {
    return {
      ...state,
      translationsStatus: {
        ...state.translationsStatus,
        [action.iso]: action.status
      }
    };
  }

  default: {
    return state;
  }

  }
};

export const getTranslationsByIso = (state, iso)=>
  get(state, `${iso}`, {});

export const getTranslationsStatusByIso = (state)=>
  state.translationsStatus;
